import { render, staticRenderFns } from "./GeneralNavigation.vue?vue&type=template&id=3573d827&"
import script from "./GeneralNavigation.vue?vue&type=script&lang=js&"
export * from "./GeneralNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports